import { html } from "lit";

import "./MediaDiff";

export type DiffOperation = "create" | "update" | "delete";

const DIFF_CONTROL_LOOKUP = {
    Media: {
        create: (object: any) =>
            html`<ds-media-diff operation="create" .media=${object}></ds-media-diff>`,
        update: (object: any) =>
            html`<ds-media-diff operation="update" .media=${object}></ds-media-diff>`,
        delete: (object: any) =>
            html`<ds-media-diff operation="delete" .media=${object}></ds-media-diff>`,
    },
};

export function getDiffControlConstructor(type: string, operation: DiffOperation) {
    if (type in DIFF_CONTROL_LOOKUP) {
        const controls = (DIFF_CONTROL_LOOKUP as any)[type];
        if (operation in controls) {
            return (controls as any)[operation];
        }
    }
    return undefined;
}

export function makeDiffControl(type: string, operation: DiffOperation, obj: any) {
    const control = getDiffControlConstructor(type, operation);
    if (control) {
        return control(obj);
    }
    return html``;
}
